import React, { useEffect, useState } from 'react';
import {
    Dialog,
    DialogBackdrop,
    DialogPanel,
    DialogTitle
} from '@headlessui/react';
import TextField from '../components/TextField';
import { Row } from "../components/Flex";
import { PrimaryButton, SecondaryButton } from '../components/buttons/Buttons';

interface Props {
    open: boolean;
    onClose: () => void;
    onCreate: (name: string) => void;
}

function CreatePortalDialog({ open, onCreate, onClose }: Props) {
    const [name, setName] = useState('');
    const [valid, setValid] = useState(false);

    const onConfirm = () => {
        onCreate(name);
        setName('');
    }

    const onClosing = () => {
        setName('');
        onClose();
    }

    useEffect(() => {
        setValid(!!name);
    }, [name]);

    return (
        <Dialog open={open} as="div" onClose={onClosing} className="dialog-container">
            <DialogBackdrop className="dialog-backdrop"/>
            <div className="dialog">
                <DialogPanel className="dialog-box">
                    <DialogTitle as="div" className="dialog-title">
                        Create portal
                    </DialogTitle>
                    <TextField label="Name" value={name} setValue={val => setName(val)} />
                    <Row gap={8} style={{ justifyContent: 'flex-end', marginTop: '8px' }}>
                        <PrimaryButton label="Create" onClick={onConfirm} disabled={!valid} />
                        <SecondaryButton label="Cancel" onClick={onClosing} />
                    </Row>
                </DialogPanel>
            </div>
        </Dialog>
    );
}

export default CreatePortalDialog;
